import _ from 'lodash'
import * as Sentry from '@sentry/browser'
import { APP_SETTINGS } from '@/common/config'
import axiosIns from '@/libs/axios'
import useJwt from '@/auth/jwt/useJwt'
import SystemHelper from '@/common/systemHelper'

export const GET_ACCOUNTS_ME = 'getAccountMe'
export const SET_ACCOUNTS_ME = 'setAccountMe'

export default {
  namespaced: true,
  state: {
    accountMe: null,
  },
  getters: {
    getCurrentAccountMe: state => {
      const currentState = state.accountMe

      if (currentState) {
        const list = currentState
        return list
      }
      return {}
    },
  },
  mutations: {
    [SET_ACCOUNTS_ME](state, val) {
      state.accountMe = val
    },
  },
  actions: {
    [GET_ACCOUNTS_ME](context, payload) {
      return new Promise((resolve, reject) => {
        const endpoint = 'account-introducer/me?skip=0&limit=100'

        axiosIns.post(`${APP_SETTINGS.BASE_URL + APP_SETTINGS.API_VERSION_NUM}${endpoint}`, payload)
          .then(res => {
            if (res.data.response_code === 2000) {
              useJwt.setToken(res.data.token)

              context.commit(SET_ACCOUNTS_ME, res.data.data.list.data[0])
              const userMeData = res.data.data.list.data[0]

              Sentry.setUser(userMeData)

              SystemHelper.successHandler(res)
              resolve(res)
            } else {
              SystemHelper.errorHandler(res)
              resolve(res)
            }
          })
          .catch(err => {
            SystemHelper.handleCatch()
            reject(err)
          })
      })
    },
  },
}
